import { Api } from '../api';

export function isB2b(stats: Api.UserStats.V): boolean {
  return !!stats.subscription?.licence?.team;
}
